// NPM
import React from "react"

// Shared Components
import Description from "src/components/Shared/Description"
import NewsItems from "src/components/Shared/NewsItems"
import SidebarLinks from "src/components/Shared/SidebarLinks"

const GenericProduct = ({
  sections,
  newsItems,
  methodology,
  language = "en",
  linksLayout = "sidebar",
}) => {
  const productSection = sections.find(s => s.uuid === "productSection")

  if (!productSection) {
    return null
  }

  const renderProductLogo = () => {
    const productLogo = productSection.media.find(m => m.uuid === "productLogo")

    if (!productLogo) {
      return null
    }

    return (
      <div className="GenericProduct__logo">
        <img src={productLogo.image?.url} alt={productLogo.imageAlt} />
      </div>
    )
  }

  const renderProductImage = () => {
    const productImage = productSection.media.find(
      m => m.uuid === "productImage",
    )

    if (!productImage) {
      return null
    }

    return (
      <div className="GenericProduct__image">
        <img src={productImage.image.url} alt={productImage.imageAlt} />
      </div>
    )
  }

  const sidebarLinks = sections
    .filter(s => s.uuid === "sidebarLink")
    .map(s => s.link)
    .map(l => ({
      text: l.text,
      url: l.url,
      page: l.page,
    }))

  const newsSection = sections.find(s => s.uuid === "newsItems")

  return (
    <div className="GenericProduct">
      <div className="GenericProduct__content">
        {renderProductLogo()}
        <h1 className="GenericProduct__title">{productSection.title}</h1>
        <Description
          className="GenericProduct__description"
          description={productSection.description}
        />
        {renderProductImage()}
        {linksLayout === "bottom" && (
          <SidebarLinks
            productSection={productSection}
            methodology={methodology}
            sidebarLinks={sidebarLinks}
            language={language}
            layout={linksLayout}
          />
        )}
      </div>
      <div className="GenericProduct__sidebar">
        {renderProductImage()}
        {linksLayout === "sidebar" && (
          <SidebarLinks
            productSection={productSection}
            methodology={methodology}
            sidebarLinks={sidebarLinks}
            language={language}
            layout={linksLayout}
          />
        )}
      </div>
      {newsSection && (
        <NewsItems
          section={newsSection}
          newsItems={newsItems}
          newsItemSearchKey={
            (
              newsSection.miscText.find(
                mt => mt.uuid === "newsItemSearchKey",
              ) || {}
            ).text
          }
        />
      )}
    </div>
  )
}

export default GenericProduct
